import React from "react";
import { Footer } from "../Footer/Footer";
import styles from "./UnauthorisedUser.module.scss";
import { Link } from "react-router-dom";

export const UnauthorisedUser = () => (
    <div className={styles.container}>
      <p>Your account isn&apos;t authorised to access this application. Try signing in with a different account or contact your administrator.</p>
      <Link to="/">Retry sign in</Link>
      <Footer />
    </div>
);
